// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import "./PredictResult.scss";

export interface IFieldItemLabelProps {
    text: string;
    changed: boolean;

    output: any;
    fieldChanged(): void;
}

export interface IFieldItemLabelState {
    inEditMode: boolean,
    fieldValue: string,
    initialValue: string,
    valueChanged: boolean,
}

export default class FieldItemLabel extends React.Component<IFieldItemLabelProps, IFieldItemLabelState> {
    private inputRef
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    public state = {
        inEditMode: false,
        fieldValue: this.props.text,
        initialValue: this.props.text,
        valueChanged: this.props.changed,
    }

    public render() {
        const text = this.state.fieldValue;
        const { inEditMode, valueChanged } = this.state;
        return (
            <>
                <div onClick={() => this.cellClick()} title='Click to edit the value' style={{ display: inEditMode ? 'none' : 'inline-block' }}>
                    <li className={"predictiontag-item-label mt-0 mb-1"}>
                        {text}
                    </li>
                    <div className="bi bi-pencil" style={{ display: 'inline-block', marginLeft: 10 }} />
                    <input
                        disabled={true}
                        className="form-check-input"
                        type="checkbox"
                        checked={valueChanged}
                        id="flexCheckDefault" />
                </div>
                <input style={{ display: inEditMode ? 'inline-block' : 'none', width: "100%" }}
                    onBlur={() => this.onInputBlur()} value={text} onChange={(e) => this.onValueChanged(e)} ref={this.inputRef} />
            </>
        )
    }

    private cellClick = () => {
        this.setState({ inEditMode: true });
        setTimeout(() => {
            // @ts-ignore
            this.inputRef.current && this.inputRef.current.focus();
        });
    }

    private onInputBlur = () => {
        this.setState({ inEditMode: false })
    }

    private onValueChanged = (event: any) => {
        const newValue = event.target.value;
        
        const changed = this.state.initialValue !== newValue;
        this.setState({ fieldValue: newValue, valueChanged: changed, });
        //dirty hack
        this.props.output.text = newValue;
        this.props.output.changed = this.state.initialValue !== newValue;

        if (changed) {
            this.props.fieldChanged();
        }
    }
}
